import ToolPage from 'components/ToolPage';
import { toolAPI } from 'utils/api';
export default function ImageToPDF() {
  return <ToolPage
    seoTitle="Image to PDF Converter Free"
    seoDesc="Convert JPG, PNG or any image into a PDF online. Free and fast, no signup."
    path="/tools/pdf/image-to-pdf"
    seoKey="image-to-pdf"
    iconName="image" title="Image to PDF" desc="Convert any image (JPG, PNG, WEBP) into a PDF document instantly." accept="image/*" hint="Supported: JPG, PNG, WEBP, GIF · Max 20MB" buttonLabel="Convert to PDF" apiCall={toolAPI.imageToPDF} outputFilename="image.pdf" infoText="The image is embedded into a PDF page sized to match your image dimensions." />;
}
